<template>
  <div>
    <div class="company-event-list-month">
      <div class="company-event-list-month-date">
        <div>{{data.month}}</div>
      </div>
    </div>
    <company-event-list-item v-for="(item, index) in data.events" :key="index" :data="item"></company-event-list-item>
  </div>
</template>

<script>
import CompanyEventListItem from '@/components/company-detail/CompanyEventListItem';

export default {
  props: {
    data: {
      type: Object
    }
  },
  components: {
    CompanyEventListItem
  }
};
</script>

<style lang="scss" scoped>
.company-event-list-month {
  position: relative;
  width: 100%;
  height: 52px;
  border-left: 2px solid #f7f7fa;
  &-date {
    position: absolute;
    left: -3px;
    top: 16px;
    width: 103px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background-color: #45a8cc;
    border-radius: 2px;
    color: #ffffff;
    font-size: 14px;
  }
}
</style>
